export const DEFAULT_VOUCHER_TEMPLATE_VOUCHER_MAX_AGE_IN_DAYS = 7;
export const DEFAULT_VOUCHER_TEMPLATE_VOUCHER_VALUE = 1;
